<template>
  <router-link :to="to" class="card">
    <v-img :height="calcCarouselheight" cover eager :src="imgSrc">
      <div class="img-section d-flex flex-column">
        <div class="section">
          <div class="border">
            <h2>{{ title }}</h2>
            <span
          v-if="isMobile"
          @click.stop.prevent="$router.push('/products')"
          class="mt-2 show-catalog-mobile"
        >{{$t("home.card.viewCataloge")}}</span>
          </div>
        </div>
        <div v-if="!isMobile" class="hover-overlay">
          <div class="hover-content">
            <h3 class="title">{{ title }}</h3>
            <p class="content">{{ content }}</p>
            <v-btn @click.stop.prevent="$router.push('/products')" :height="50" class="btn">צפייה בקטלוג</v-btn>
          </div>
        </div>
      </div>
    </v-img>
  </router-link>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "CardsView",
  props: {
    imgSrc: {
      type: String
    },
    title: {
      type: String
    },
    content: {
      type: String
    },
    to: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      isMobile: "isMobile",
      isLaptop: "isLaptop",
      isTablet: "isTablet",
      isDesktop: "isDesktop"
    }),
    calcCarouselheight() {
      if (this.isDesktop) {
        return 550;
      } else if (this.isLaptop) {
        return 500;
      } else if (this.isTablet) {
        return 450;
      } else {
        return 400;
      }
    }
  }
};
</script>

<style lang="scss">
.card {
  text-decoration: none;
  color: inherit;
  img {
    border-radius: 10px;
  }
  &:hover {
    cursor: pointer;
  }
}
</style>
<style lang="scss" scoped>
.card {
  width: 100%;

  .hover-overlay {
    opacity: 0;
    width: 100%;
    height: 100%;
    transition: opacity 0.5s ease;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &:hover {
    cursor: pointer;

    .hover-overlay {
      opacity: 1;
      background: rgb(0 0 0 / 60%);
      border-radius: 10px;
      transition: opacity 0.5s ease;
    }
    .title {
      color: white;
      font-size: 30px;
    }
    .content {
      color: white;
    }
    .btn {
      max-width: fit-content;
      text-decoration: underline;
      font-weight: 300;
      font-size: 20px;
    }

    .hover-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 20px;
      gap: 20px;
    }

    .section {
      display: none;
    }

    @media (max-width: 601px) {
      .section {
        display: unset;
      }
    }
  }
}
img {
  //   max-height: 550px !important;
}
.show-catalog-mobile {
  color: $iconColor;
  font-size: 16px;
  text-decoration: underline;
  cursor: pointer;
}
.img-section {
  height: 100% !important;
  display: flex;
  justify-content: center;
  align-items: center;
  .section {
    height: 200px;
    width: 200px;
    background: #ffffffcc;
    padding: 10px;
    border-radius: 5px;
    .border {
      height: 100%;
      width: 100%;
      border: 1px solid #2c2c2c;
      border-radius: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
  }
}
h2 {
  font-family: Heebo;
  font-size: 30px;
  font-weight: 300;
  line-height: 44.06px;
  letter-spacing: 0.05em;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}
.isTablet,
.isMobile {
  .img-section {
    .section {
      height: 150px;
      width: 150px;
      h2 {
        font-size: 25px;
      }
    }
  }
  .btn {
    font-weight: 300;
    font-size: 18px !important;
  }
}
</style>
